import client from "./client";

const getInvoices = () => client.get("/subsidiary/dashboard/invoice/all");

export default { getInvoices };
